import { Stream } from "@cloudflare/stream-react";
import {
  StyleSheet,
  useWindowDimensions,
  View,
  type ViewStyle,
} from "react-native";

export function CloudflareStream({
  style,
  videoId,
}: {
  style?: ViewStyle;
  videoId: string;
}) {
  const { height: windowHeight } = useWindowDimensions();
  const heightPx = Math.round(windowHeight * 0.8);
  const widthPx = Math.round(heightPx * (1206 / 2622));

  return (
    <View style={[styles.container, style]}>
      <Stream
        autoplay
        controls={false}
        height={`${heightPx}px`}
        loop
        muted
        preload="auto"
        responsive={false}
        src={videoId}
        width={`${widthPx}px`}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    aspectRatio: 1206 / 2622,
    backgroundColor: "transparent",
    borderColor: "rgba(255, 255, 255, 0.9)",
    borderRadius: 30,
    borderWidth: 2,
    height: "80vh" as unknown as number,
    overflow: "hidden",
  },
});
